// Soft two-note chime (Web Audio, no asset) for new-booking alerts. Resolves false
// when the browser blocks audio (no prior user gesture) so callers can degrade quietly.
export function playBookingChime() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return false;
    const ctx = new Ctx();
    const master = ctx.createGain();
    master.gain.value = 0.0001;
    master.connect(ctx.destination);
    const t0 = ctx.currentTime;
    // gentle fade in/out so it never clicks or startles
    master.gain.exponentialRampToValueAtTime(0.18, t0 + 0.02);
    master.gain.exponentialRampToValueAtTime(0.0001, t0 + 1.6);
    [[660, 0], [880, 0.22]].forEach(([freq, delay]) => {
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      g.gain.value = 0.0001;
      g.gain.exponentialRampToValueAtTime(1, t0 + delay + 0.03);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + delay + 1.2);
      osc.connect(g); g.connect(master);
      osc.start(t0 + delay); osc.stop(t0 + delay + 1.25);
    });
    setTimeout(() => ctx.close().catch(() => {}), 2000);
    if (ctx.state === "suspended") { ctx.resume().catch(() => {}); }
    return true;
  } catch {
    return false;
  }
}
